import React, { useContext, useRef, useState, useEffect, createRef } from 'react';
import useTranslations from './../utils/useTranslations';
import Button from '../components/button';
import { CompatibilityContext } from './compatibilityContext';
import { LocaleContext } from './layout';
import { PromoPopup, PromoPopupHandler, promoPrices, getPromoLinks } from '../components/promo';
import { Link } from 'gatsby';
import { WebAfUT, WebPro, WebProVpn, WebAfBT } from './cartLinks';
import { ANDROID_LINK_FREE, ANDROID_LINK_PRO, getAndroidLink } from '../utils/getAndroidLink';
import { getCountry } from '../utils/country';
import BenchClient from '../utils/benchClient';
import { addUrlParameter } from '../utils';
import AnniversaryPromo from './anniversaryPromo';
import { NEO_DOWNLOAD_ROUTE } from '../constants/bittorrentNeo';

const ComparisonPanels = ({ pageContext: { text, pageName, isMac }, noShadow, children }) => {
    const t = useTranslations(text);
    const page = pageName;
    const compatibilityHandler = useContext(CompatibilityContext);
    const { locale } = React.useContext(LocaleContext);
    const googlePlayButton = `/images/google-play-badges/google-play-badge-${locale}.png`;
    var product;
    var productOs;
    var pageType;
    var buyWithCrypto;
    var buyWebWithCrypto;
    var titleProduct;

    const subtitles = {};
    subtitles.basic = useRef(null);
    subtitles.adFree = useRef(null);
    subtitles.pro = useRef(null);
    subtitles.proVPN = useRef(null);

    const panel = {};
    panel.basic = useRef(null);
    panel.adFree = useRef(null);
    panel.pro = useRef(null);
    panel.proVPN = useRef(null);

    const freePriceInnerRef = useRef(null);
    const [subtitleStyle, setSubtitleStyle] = useState({});
    const [freePriceStyle, setFreePriceStyle] = useState({});
    console.log('isMac',isMac)
    const [adfreePrice, setAdfreePrice] = useState('$6.95');
    const proVpnNotSupportedGeos = ['IN'];

    const [isProVPNSupported, setIsProVPNSupported] = useState(true);

    const [androidLinkFree, setAndroidLinkFree] = useState(ANDROID_LINK_FREE);
    const [androidLinkPro, setAndroidLinkPro] = useState(ANDROID_LINK_PRO);

    function adjustSubtitleHeight() {
        let maxHeight = 0;
        for (let key in subtitles) {
            if (subtitles[key].current.clientHeight) {
                let currentHeight = subtitles[key].current.clientHeight;

                if (maxHeight < currentHeight) {
                    maxHeight = currentHeight;
                }
            }
        }

        setSubtitleStyle({
            height: `${maxHeight}px`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        });
    }

    function adjustFreePriceFontSize() {
        let parentWidth = panel.basic.current.clientWidth;
        if (parentWidth !== 0) {
            let width = freePriceInnerRef.current.clientWidth;
            if (width > parentWidth - 30) {
                let fs = window.getComputedStyle(freePriceInnerRef.current, null).getPropertyValue('font-size');
                fs = parseFloat(fs);
                let newFs = fs - 5 + 'px';
                setFreePriceStyle({
                    fontSize: newFs,
                    lineHeight: 'normal',
                });
            }
        }
    }

    function handleVPNSuppport(countryCode) {
        if (
            proVpnNotSupportedGeos.includes(countryCode) &&
            (page === 'products' || product === 'Web' || product === 'Classic')
        ) {
            setIsProVPNSupported(false);
        }
    }

    useEffect(() => {
        const d = async () => {
            adjustSubtitleHeight();
            let countryCode = await getCountry();
            handleVPNSuppport(countryCode);
            setAndroidLinkFree(getAndroidLink('free'));
            setAndroidLinkPro(getAndroidLink('pro'));
        };
        d();
    }, []);

    useEffect(() => {
        adjustFreePriceFontSize();
    }, [freePriceStyle]);

    if (page === 'products') {
        var homepage = true;
        var panelGutter = true;
        productOs = ['Win'];
        pageType = 'home';
    }
    if (page === 'products_win_web-free') {
        var btwebfree = true;
        var panelGutter = false;
        product = 'Web';
        productOs = ['Win'];
        titleProduct = true;
        buyWebWithCrypto = false;
    }
    if (page === 'products_mac_web-free') {
        var btwebfree = true;
        var panelGutter = false;
        product = 'Web';
        productOs = ['Osx'];
        titleProduct = true;
        buyWebWithCrypto = false;
    }
    if (page === 'products_win_web-premium') {
        var webPremium = true;
        var panelGutter = false;
        product = 'Web';
        productOs = ['Win'];
        titleProduct = true;
        buyWebWithCrypto = false;
    }
    if (page === 'products_win_web-compare') {
        var webcompare = true;
        var panelGutter = false;
        product = 'Web';
        productOs = ['Win'];
        titleProduct = true;
        buyWebWithCrypto = false;
    }
    if (page === 'products_mac_web-compare') {
        var webcompare = true;
        var panelGutter = false;
        product = 'Web';
        productOs = ['Osx'];
        titleProduct = true;
        buyWebWithCrypto = false;
        var showEULA = true;
    }
    if (page === 'products_win_classic-free') {
        var classicfree = true;
        product = 'Classic';
        productOs = ['Win'];
        pageType = 'free';
        buyWithCrypto = false;
        titleProduct = true;
    }
    if (page === 'products_win_classic-premium') {
        var classicPremium = true;
        product = 'Classic';
        productOs = ['Win'];
        pageType = 'premium';
        buyWithCrypto = false;
        titleProduct = true;
    }
    if (page === 'products_win_classic-compare') {
        var classiccompare = true;
        product = 'Classic';
        productOs = ['Win'];
        pageType = 'panels';
        buyWithCrypto = false;
        titleProduct = true;
    }
    if (page === 'products_android_android-free') {
        var androidfree = true;
        product = 'Android';
        productOs = ['Android'];
    }
    if (page === 'products_android_android-pro') {
        var androidpro = true;
        product = 'Android';
        productOs = ['Android'];
    }

    var linkBasic = '/downloads/complete';
    if (classiccompare || classicPremium || classicfree) {
        linkBasic = '/downloads/complete/classic';
    }

    var webProVPNLink = productOs.includes('Osx') ? WebProVpn.webMac : WebProVpn.webWin;
    var webProLink = productOs.includes('Osx') ? WebPro.webMac : WebPro.webWin;
    var webAdFreeLink = productOs.includes('Osx') ? WebAfBT.webMac : WebAfBT.webWin;

    const brand = process.env.BRAND === 'bt' ? 'b' : 'u';
    var proVPNLink = `https://store.bittorrent.com/${brand}_c_pv_w`;
    var proLink = `https://store.bittorrent.com/${brand}_c_p_w`;
    var adFreeLink = `https://store.bittorrent.com/${brand}_c_af_w`;

    if (product === 'Web') {
        proVPNLink = webProVPNLink;
        proLink = webProLink;
        adFreeLink = webAdFreeLink;
    }

    let proVPNCryptoLink = 'https://cryptopayments.bittorrent.com/checkout/?add-to-cart=83';
    let proCryptoLink = 'https://cryptopayments.bittorrent.com/checkout/?add-to-cart=14';
    let adFreeCryptoLink = 'https://cryptopayments.bittorrent.com/checkout/?add-to-cart=96';

    let webProVPNCryptoLink = 'https://cryptopayments.bittorrent.com/checkout/?add-to-cart=1538';
    let webProCryptoLink = 'https://cryptopayments.bittorrent.com/checkout/?add-to-cart=1537';

    const isPromoCalloutPage =
        homepage || btwebfree || webPremium || webcompare || classicfree || classicPremium || classiccompare;
    const showAnniversaryPromo =
        page === 'products_mac_web-free' ||
        page === 'products_win_web-free' ||
        page === 'products_win_web-premium' ||
        page === 'products_win_classic-free' ||
        page === 'products_win_classic-premium' ||
        page === 'products_mac_web-compare' ||
        page === 'products_win_web-compare' ||
        page === 'products_win_classic-compare';
    const { handlePromoPopupClose, handlePromoPopupOpen, showPromoDiscount, showPromoPopup } = PromoPopupHandler();

    const showAnyPromo =
        typeof showPromoDiscount === 'boolean'
            ? showPromoDiscount
            : Object.values(showPromoDiscount).some((promo) => promo === true);
    //showPromoDiscount is always false
    const showProVpnPromo = typeof showPromoDiscount === 'boolean' ? showPromoDiscount : showPromoDiscount.proVpn;
    const showProPromo = typeof showPromoDiscount === 'boolean' ? showPromoDiscount : showPromoDiscount.pro;
    const showAdFreePromo = typeof showPromoDiscount === 'boolean' ? showPromoDiscount : showPromoDiscount.adFree;

    let panelShadowNone = noShadow ? 'panelShadowNone' : '';
    let panelTriplet = panelGutter ? 'sexy-panel' : '';
    let panelNoBorder = panelGutter ? 'sexy-promo-panel-too' : '';
    let panelPromo = showAnyPromo ? 'panel-promo' : '';

    const popupRef = createRef();

    const handleClick = (e, link, type, homepageProduct) => {
        // show promoPopup on free download click
        // when popup is not visible
        // and not already showing promo discounts
        // use false if statement to disable promotion
        // if(action === "downloading" && !showPromoPopup && !showPromoDiscount) {
        if (false) {
            handlePromoPopupOpen(popupRef, e);
        } else {
            const action = type === 'basic' ? 'download' : 'buy';
            const productName = product ? product : homepageProduct ? homepageProduct : 'Unknown';
            const alternativeDownload =
                process.env.BRAND === 'bt' &&
                action === 'download' &&
                (page === 'products_win_classic-compare' ||
                    page === 'products_win_classic-free' ||
                    page === 'products_win_classic-premium')
                    ? {
                          product: 'Neo',
                          link: NEO_DOWNLOAD_ROUTE,
                      }
                    : null;

            compatibilityHandler(e, `${action}ing`, productName, productOs, link, alternativeDownload);
            BenchClient.ping(`click.${productName.toLowerCase()}_${action}.${type}`);
        }
    };

    //////
    const [webProLink2, setwebProLink2] = useState(webProLink);
    const [webProVPNLink2, setwebProVPNLink2] = useState(webProVPNLink);
    const [webProCryptoLink2, setwebProCryptoLink2] = useState(webProCryptoLink);
    const [webProVPNCryptoLink2, setwebProVPNCryptoLink2] = useState(webProVPNCryptoLink);
    const [proLink2, setproLink2] = useState(proLink);
    const [proVPNLink2, setproVPNLink2] = useState(proVPNLink);
    const [proCryptoLink2, setproCryptoLink2] = useState(proCryptoLink);
    const [proVPNCryptoLink2, setproVPNCryptoLink2] = useState(proVPNCryptoLink);
    const [webAdFreeLink2, setwebAdFreeLink2] = useState(webAdFreeLink);
    const [adFreeLink2, setadFreeLink2] = useState(adFreeLink);
    const [adFreeCryptoLink2, setadFreeCryptoLink2] = useState(adFreeCryptoLink);

    const promoPercent = promoPrices.percent;

    useEffect(() => {
        let webProVPNLink = productOs.includes('Osx') ? WebProVpn.webMac : WebProVpn.webWin;
        let webProLink = productOs.includes('Osx') ? WebPro.webMac : WebPro.webWin;
        let webAdFreeLink =
            process.env.BRAND === 'bt'
                ? productOs.includes('Osx')
                    ? WebAfBT.webMac
                    : WebAfBT.webWin
                : productOs.includes('Osx')
                  ? WebAfUT.webMac
                  : WebAfUT.webWin;

        let proVPNLink = `https://store.bittorrent.com/${brand}_c_pv_w`;
        let proLink = `https://store.bittorrent.com/${brand}_c_p_w`;
        // let adFreeLink = process.env `https://store.bittorrent.com/${brand}_c_af_w`;
        let adFreeLink =
            process.env.BRAND === 'bt'
                ? `https://store.payproglobal.com/checkout?products[1][id]=120536`
                : `https://store.payproglobal.com/checkout?products[1][id]=100720`;
        if (product === 'Web') {
            proVPNLink = webProVPNLink;
            proLink = webProLink;
            adFreeLink = webAdFreeLink;
        }
        // always false
        if (showProPromo) {
            const newLinks = getPromoLinks({ webProLink, proLink });
            webProLink = newLinks.webProLink;
            proLink = newLinks.proLink;
        }
        if (showProVpnPromo) {
            const newLinks = getPromoLinks({ webProVPNLink, proVPNLink });
            webProVPNLink = newLinks.webProVPNLink;
            proVPNLink = newLinks.proVPNLink;
        }
        if (showAdFreePromo) {
            const newLinks = getPromoLinks({ webAdFreeLink, adFreeLink });
            webAdFreeLink = newLinks.webAdFreeLink;
            adFreeLink = newLinks.adFreeLink;
        }

        setwebProLink2(addUrlParameter(webProLink, 'x-source', 'bts'));
        setwebProVPNLink2(addUrlParameter(webProVPNLink, 'x-source', 'bts'));
        setwebProCryptoLink2(addUrlParameter(webProCryptoLink, 'x-source', 'bts'));
        setwebProVPNCryptoLink2(addUrlParameter(webProVPNCryptoLink, 'x-source', 'bts'));
        setproLink2(addUrlParameter(proLink, 'x-source', 'bts'));
        setproVPNLink2(addUrlParameter(proVPNLink, 'x-source', 'bts'));
        setproCryptoLink2(addUrlParameter(proCryptoLink, 'x-source', 'bts'));
        setproVPNCryptoLink2(addUrlParameter(proVPNCryptoLink, 'x-source', 'bts'));
        setwebAdFreeLink2(addUrlParameter(webAdFreeLink, 'x-source', 'bts'));
        setadFreeLink2(addUrlParameter(adFreeLink, 'x-source', 'bts'));
        setadFreeCryptoLink2(addUrlParameter(adFreeCryptoLink, 'x-source', 'bts'));
    }, [isMac, showProPromo, showProVpnPromo, showAdFreePromo]);
    ///////

    useEffect(()=>{
        if(process.env.BRAND !== 'bt' && productOs.includes('Osx')){
            setAdfreePrice('$4.95')
        }else{
            setAdfreePrice('$6.95')
        }
    },[productOs])

    const buttonClass = process.env.BRAND === 'bt' ? 'tw-btn-outline' : 'tw-btn-filled';

    return (
        <>
            <div id="comparison-panels" className="container mt-5 px-0">
                {showAnniversaryPromo && <AnniversaryPromo />}
                <div className="row d-flex align-items-start justify-content-center mx-0">
                    <div
                        ref={panel.proVPN}
                        className={
                            androidfree === true || androidpro === true || !isProVPNSupported
                                ? 'd-none'
                                : `col-12 col-sm-10 col-md-8 col-lg-3 order-3 order-lg-1 d-flex flex-column
                                    align-items-center justify-content-start panelShadow panelWidth panelOther
                                    ${panelShadowNone} ${panelNoBorder} ${panelPromo}`
                        }
                    >
                        <div className="panelTitle mt-4">PRO+VPN</div>
                        {titleProduct && <p className="panelTitleProduct"> for {product}</p>}
                        <div className="panelSubtitle mt-3 mb-4" ref={subtitles.proVPN} style={subtitleStyle}>
                            <div>{t('provpnPanelTitle')}</div>
                        </div>
                        <div className="panelSubline mb-4">&nbsp;</div>
                        <div>
                            <div className="panelsPrice">
                                {!showProVpnPromo || !isPromoCalloutPage ? (
                                    '$69.95'
                                ) : (
                                    <>
                                        <div className="promo-limited-time">{t('Limited Time Only')}</div>
                                        <div className="promo-percent-off">
                                            {promoPercent} {t('Off')}
                                        </div>
                                        <div className="promo-list-price">
                                            {t('List Price')}:<span className="promo-original-price">$69.95</span>
                                        </div>
                                    </>
                                )}
                            </div>

                            <div className="panelsPeriod mb-3">{t('per year')}</div>
                        </div>
                        <Button
                            panel={panel.proVPN}
                            onClick={(e) => handleClick(e, proVPNLink2, 'provpn')}
                            id="panels-provpn-buynow"
                            href={proVPNLink2}
                            type="button"
                            className={homepage === true ? 'd-none' : buttonClass}
                        >
                            {t('BUY NOW')}
                        </Button>
                        <div
                            className={homepage === true ? 'd-flex align-items-center justify-content-start' : 'd-none'}
                        >
                            <Button
                                id="panels-hp-web-provpn-link"
                                onClick={(e) => handleClick(e, webProVPNLink2, 'provpn', 'Web')}
                                href={webProVPNLink2}
                                type="button"
                                className="btn btn-primary button-filled button-panels"
                            >
                                WEB
                            </Button>
                            <Button
                                id="panels-hp-classic-provpn-link"
                                onClick={(e) => handleClick(e, proVPNLink2, 'provpn', 'Classic')}
                                href={proVPNLink2}
                                type="button"
                                className="btn btn-outline-primary button-outlined ml-2 button-panels"
                            >
                                CLASSIC
                            </Button>
                        </div>
                        {buyWithCrypto && (
                            <div className="mt-2 mb-1 text text-center">
                                <a
                                    onClick={(e) => handleClick(e, proVPNCryptoLink2, 'provpn')}
                                    href={proVPNCryptoLink2}
                                    id="panels-provpn-buynow-crypto"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    <u>{t(`Buy with crypto`)}</u>
                                </a>
                            </div>
                        )}
                        {buyWebWithCrypto && (
                            <div className="mt-2 mb-1 text text-center">
                                <a
                                    onClick={(e) => handleClick(e, webProVPNCryptoLink2, 'provpn')}
                                    href={webProVPNCryptoLink2}
                                    id="panels-web-provpn-buynow-crypto"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    <u>{t(`Buy with crypto`)}</u>
                                </a>
                            </div>
                        )}
                        <div className="mt-4 mw-100">
                            <div
                                className={
                                    classicPremium === true ||
                                    classicfree === true ||
                                    homepage === true ||
                                    btwebfree === true ||
                                    webPremium === true
                                        ? 'panelBullets w-100 uniform'
                                        : 'panelBullets w-100 uniform-short'
                                }
                            >
                                <li>{t('provpnBullet1')}</li>
                                <li>{t('provpnBullet2')}</li>
                                <li>{t('provpnBullet3')}</li>
                                <li className={classiccompare || webcompare || btwebfree ? 'd-none' : ''}>
                                    {t('provpnBullet4')}
                                </li>
                                <li className={classicPremium !== true ? 'd-none' : ''}>{t('provpnBullet5')}</li>
                            </div>
                        </div>
                    </div>
                    <div
                        ref={panel.pro}
                        className={`col-12 col-sm-10 col-md-8 col-lg-3 order-1 order-lg-2 d-flex flex-column
                            align-items-center justify-content-start panelShadowpop panelWidth px-0 mx-0
                            ${panelShadowNone} ${panelTriplet} ${panelPromo}`}
                    >
                        {
                            //remove most popular for android
                        }
                        {product === 'Web' && (
                            <div className="panels-new-improved-badge">
                                <div className="badge-text">{t('New & improved')}</div>
                            </div>
                        )}
                        <div
                            className="tw-mb-2 tw-flex tw-h-[64px] tw-w-full tw-items-center tw-justify-center tw-bg-btn
                                tw-text-center tw-text-2xl tw-tracking-[2px] tw-text-white"
                        >
                            {t('POPULAR')}
                        </div>
                        <div className="panelTitle d-flex align-items-center mt-4">
                            {product === 'Classic' && <div className="new-badge">{t('NEW')}</div>}
                            PRO
                        </div>
                        {titleProduct && <p className="panelTitleProduct"> for {product}</p>}
                        <div className="panelSubtitle px-3 mt-3 mb-4" ref={subtitles.pro} style={subtitleStyle}>
                            <div>{t('proPanelTitle')}</div>
                        </div>
                        <div className="panelSubline mb-4">&nbsp;</div>
                        <div>
                            <div className="panelsPrice px-3">
                                {/* {(((!showPromoDiscount) || !isPromoCalloutPage)) */}
                                {!showProPromo || !isPromoCalloutPage ? (
                                    <span
                                        className={androidpro === true || androidfree === true ? 'd-none' : 'd-block'}
                                    >
                                        $19.95
                                    </span>
                                ) : (
                                    <>
                                        <div className="promo-limited-time">{t('Limited Time Only')}</div>
                                        <div className="promo-percent-off">
                                            {promoPercent} {t('Off')}
                                        </div>
                                        <div className="promo-list-price">
                                            {t('List Price')}:<span className="promo-original-price">$19.95</span>
                                        </div>
                                    </>
                                )}
                                {(androidpro === true || androidfree === true) && !isPromoCalloutPage && (
                                    <span className="d-block">$3.99</span>
                                )}
                            </div>

                            <div
                                className={
                                    androidpro === true || androidfree === true ? 'invisible mb-3' : 'panelsPeriod mb-3'
                                }
                            >
                                {t('per year')}
                            </div>
                        </div>
                        <Button
                            panel={panel.pro}
                            onClick={(e) => handleClick(e, proLink2, 'pro')}
                            id="panels-pro-buynow"
                            href={proLink2}
                            type="button"
                            className={
                                homepage === true || androidpro === true || androidfree === true
                                    ? 'd-none'
                                    : buttonClass
                            }
                        >
                            {t('BUY NOW')}
                        </Button>
                        {product === 'Classic' && process.env.BRAND === 'bt' && (
                            <a
                                className="panels-pro-free-trial-link mt-3"
                                href="https://store.bittorrent.com/849/purl-btprotrialweb14"
                                target="_blank"
                            >
                                {t('Or try free for 14 days')}
                            </a>
                        )}
                        <div
                            className={homepage === true ? 'd-flex align-items-center justify-content-start' : 'd-none'}
                        >
                            <Button
                                id="panels-hp-web-pro-link"
                                onClick={(e) => handleClick(e, webProLink2, 'pro', 'Web')}
                                href={webProLink2}
                                type="button"
                                className="btn btn-primary button-filled button-panels"
                            >
                                WEB
                            </Button>
                            <Button
                                id="panels-hp-classic-pro-link"
                                onClick={(e) => handleClick(e, proLink2, 'pro', 'Classic')}
                                href={proLink2}
                                type="button"
                                className="btn btn-outline-primary button-outlined ml-2 button-panels"
                            >
                                CLASSIC
                            </Button>
                        </div>
                        <a
                            href={androidLinkPro}
                            id="panels-android-pro"
                            className={
                                androidpro === true || androidfree === true ? 'index-mobile-google-play' : 'd-none'
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                className="google-play-button img-fluid"
                                src={googlePlayButton}
                                alt="BitTorrent Pro for Android Google Play Store badge"
                            ></img>
                        </a>
                        {buyWithCrypto && (
                            <div className="mt-2 mb-1 text text-center">
                                <a
                                    onClick={(e) => handleClick(e, proCryptoLink2, 'pro')}
                                    href={proCryptoLink2}
                                    id="panels-pro-buynow-crypto"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    <u>{t(`Buy with crypto`)}</u>
                                </a>
                            </div>
                        )}
                        {buyWebWithCrypto && (
                            <div className="mt-2 mb-1 text text-center">
                                <a
                                    onClick={(e) => handleClick(e, webProCryptoLink2, 'pro')}
                                    href={webProCryptoLink2}
                                    id="panels-web-pro-buynow-crypto"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    <u>{t(`Buy with crypto`)}</u>
                                </a>
                            </div>
                        )}
                        <div className="mx-3 mt-4 mw-100">
                            <div
                                className={
                                    classicPremium === true ||
                                    classicfree === true ||
                                    homepage === true ||
                                    btwebfree === true ||
                                    webPremium === true
                                        ? 'panelBullets w-100 h-100 uniform'
                                        : 'panelBullets w-100 h-100 uniform-short'
                                }
                            >
                                <li>{t('proBullet1')}</li>
                                <li>{t('proBullet2')}</li>
                                <li>{t('proBullet3')}</li>
                                <li
                                    className={
                                        classiccompare === true || webcompare === true || btwebfree || webPremium
                                            ? 'd-none'
                                            : ''
                                    }
                                >
                                    {t('proBullet4')}
                                </li>
                                <li
                                    className={
                                        homepage === true ||
                                        androidpro === true ||
                                        androidfree === true ||
                                        classiccompare === true ||
                                        webcompare === true ||
                                        btwebfree === true ||
                                        webPremium === true
                                            ? 'd-none'
                                            : ''
                                    }
                                >
                                    {t('proBullet5')}
                                </li>
                                {/* <li className={(classicPremium === true) && (btwebfree !== true || webPremium === true) ? '' : 'd-none'}>{t("proBullet6")}</li> */}
                            </div>
                        </div>
                    </div>
                    <div
                        ref={panel.adFree}
                        className={
                            androidfree === true || androidpro === true
                                ? 'd-none'
                                : `col-12 col-sm-10 col-md-8 col-lg-3 order-2 order-lg-3 d-flex flex-column
                                    align-items-center justify-content-start panelShadowaf panelWidth panelOther
                                    ${panelShadowNone} ${panelNoBorder} ${panelPromo}`
                        }
                    >
                        <div className="panelTitle mt-4">AD-FREE</div>
                        {titleProduct && <p className="panelTitleProduct"> for {product}</p>}
                        <div className="panelSubtitle mt-3 mb-4" ref={subtitles.adFree} style={subtitleStyle}>
                            <div>{t('afPanelTitle')}</div>
                        </div>
                        <div className="panelSubline mb-4">&nbsp;</div>
                        <div>
                            <div className="panelsPrice">
                                {/* {((!showPromoDiscount || !isPromoCalloutPage)) */}
                                {/* true flag to disable ad free promo */}
                                {!showAdFreePromo ? (
                                    adfreePrice
                                ) : (
                                    <>
                                        <div className="promo-limited-time">{t('Limited Time Only')}</div>
                                        <div className="promo-percent-off">
                                            {promoPercent} {t('Off')}
                                        </div>
                                        <div className="promo-list-price">
                                            {t('List Price')}:<span className="promo-original-price">{adfreePrice}</span>
                                        </div>
                                    </>
                                )}
                            </div>
                            <div className="panelsPeriod mb-3">{t('per year')}</div>
                        </div>
                        <Button
                            panel={panel.adFree}
                            onClick={(e) => handleClick(e, adFreeLink2, 'adfree')}
                            id="panels-af-buynow"
                            href={adFreeLink2}
                            type="button"
                            className={homepage === true ? 'd-none' : buttonClass}
                        >
                            {t('BUY NOW')}
                        </Button>
                        <div
                            className={homepage === true ? 'd-flex align-items-center justify-content-start' : 'd-none'}
                        >
                            <Button
                                id="panels-hp-web-af-link"
                                onClick={(e) => handleClick(e, webAdFreeLink2, 'adfree', 'Web')}
                                href={webAdFreeLink2}
                                type="button"
                                className="btn btn-primary button-filled button-panels"
                            >
                                WEB
                            </Button>
                            <Button
                                id="panels-hp-classic-af-link"
                                onClick={(e) => handleClick(e, adFreeLink2, 'adfree', 'Classic')}
                                href={adFreeLink2}
                                type="button"
                                className="btn btn-outline-primary button-outlined ml-2 button-panels"
                            >
                                CLASSIC
                            </Button>
                        </div>
                        {buyWithCrypto && (
                            <div className="mt-2 text text-center">
                                <a
                                    onClick={(e) => handleClick(e, adFreeCryptoLink2, 'adfree')}
                                    href={adFreeCryptoLink2}
                                    id="panels-af-buynow-crypto"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    <u>{t(`Buy with crypto`)}</u>
                                </a>
                            </div>
                        )}
                        {buyWebWithCrypto && <div className="mt-2 text crypto-logos-space">&nbsp;</div>}
                        <div className="mt-4 mw-100">
                            <div
                                className={
                                    classicPremium === true ||
                                    classicfree === true ||
                                    homepage === true ||
                                    btwebfree ||
                                    webPremium
                                        ? 'panelBullets w-100 uniform'
                                        : 'panelBullets w-100 uniform-short'
                                }
                            >
                                <li>{t('afBullet1')}</li>
                                <li>{t('afBullet2')}</li>
                                <li>{t('afBullet3')}</li>
                            </div>
                        </div>
                    </div>
                    <div
                        ref={panel.basic}
                        id="basicpanel"
                        className={
                            homepage === true
                                ? 'd-none'
                                : `col-12 col-sm-10 col-md-8 col-lg-3 order-4 d-flex flex-column align-items-center
                                    justify-content-start panelShadow panelWidth panelOther ${panelShadowNone}
                                    ${panelPromo}`
                        }
                    >
                        <div className="panelTitle mt-4">BASIC</div>
                        {titleProduct && <p className="panelTitleProduct"> for {product}</p>}
                        <div className="panelSubtitle mt-3 mb-4" ref={subtitles.basic} style={subtitleStyle}>
                            <div>{t('basicPanelTitle')}</div>
                        </div>
                        <div className="panelSubline mb-4">&nbsp;</div>
                        <div>
                            <div className="panelsPrice">
                                <span
                                    style={freePriceStyle}
                                    className="text-nowrap d-inline-block"
                                    ref={freePriceInnerRef}
                                >
                                    {t('FREE')}
                                </span>
                            </div>
                            <div className="panelsPeriod mb-3">&nbsp;</div>
                        </div>
                        <Button
                            panel={panel.basic}
                            onClick={(e) => {
                                handleClick(e, linkBasic, 'basic');
                            }}
                            id="panels-basic-dlnow"
                            href={linkBasic}
                            type="button"
                            className={androidpro === true || androidfree === true ? 'd-none' : buttonClass}
                        >
                            {t('DOWNLOAD NOW')}
                        </Button>
                        <a
                            href={androidLinkFree}
                            id="panels-android-free"
                            className={
                                androidpro === true || androidfree === true ? 'index-mobile-google-play' : 'd-none'
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                className="google-play-button img-fluid"
                                src={googlePlayButton}
                                alt="BitTorrent for Android Google Play Store badge"
                            ></img>
                        </a>
                        {(buyWithCrypto || buyWebWithCrypto) && (
                            <div className="mt-2 text crypto-logos-space">&nbsp;</div>
                        )}
                        <div className="mt-4 mw-100">
                            <div
                                className={
                                    classicPremium === true ||
                                    classicfree === true ||
                                    homepage === true ||
                                    btwebfree === true ||
                                    webPremium === true
                                        ? 'panelBullets w-100 uniform'
                                        : 'panelBullets w-100 uniform-short'
                                }
                            >
                                <li>{t('basicBullet1')}</li>
                                <li className={androidpro === true || androidfree === true ? '' : 'd-none'}>
                                    {t('basicBullet2')}
                                </li>
                                <li className={androidpro === true || androidfree === true ? '' : 'd-none'}>
                                    {t('basicBullet3')}
                                </li>
                                {showEULA && (
                                    <div className="panels-eula-container">
                                        <div className="text panels-eula-text mt-2">
                                            {t(
                                                'By clicking Download Now, you agree to our Terms of Use, EULA & Privacy Policy',
                                                {
                                                    'Terms of Use': (
                                                        <Link to="/legal/terms-of-use/" target="_blank">
                                                            {t(`Terms of Use`)}
                                                        </Link>
                                                    ),
                                                    EULA: (
                                                        <Link to="/legal/eula/" target="_blank">
                                                            {t(`EULA`)}
                                                        </Link>
                                                    ),
                                                    'Privacy Policy': (
                                                        <Link to="/legal/privacy-policy/" target="_blank">
                                                            {t(`Privacy Policy`)}
                                                        </Link>
                                                    ),
                                                }
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {children}
            </div>
            {/* <PromoPopup show={showPromoPopup} ref={popupRef} closeEvent = {handlePromoPopupClose}/>         */}
        </>
    );
};

export default ComparisonPanels;
